import { render, staticRenderFns } from "./rating_stars.vue?vue&type=template&id=07225b97&"
import script from "./rating_stars.vue?vue&type=script&lang=js&"
export * from "./rating_stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports